<template>
  <va-sidebar :minimized="minimized">
    <template slot="menu">
      <template v-for="(item, key) in items">
        <va-sidebar-link-group
          :key="key"
          :minimized="minimized"
          :icon="[ 'sidebar-menu-item-icon', validateClass(item.meta[0].iconClass)]"
          v-if="item.children"
          :title="$t(item.displayName)"
          :children="item.children"
        >
        <template v-for="(subMenuItem, key) in item.children">
          <va-sidebar-link
            v-if="subMenuItem.target === ''"
            :key="key"
            :to="subMenuItem.name"
            :title="$t(subMenuItem.displayName)"
          />
          <a v-else :href="subMenuItem.name" class="va-sidebar-link" :target="subMenuItem.target" style="" @click="newpage">
            <div class="va-sidebar-link__content__title">
              {{subMenuItem.displayName}}
            </div>
          </a>
        </template>
        </va-sidebar-link-group>
        <va-sidebar-link
          v-else

          :minimized="minimized"
          :activeByDefault="item.name === $route.name"
          :icon="[ 'sidebar-menu-item-icon', validateClass(item.meta[0].iconClass)]"
          :to="{ name: item.name }">
          <span slot="title">{{ $t(item.displayName) }}</span>
        </va-sidebar-link>
      </template>
    </template>
  </va-sidebar>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'app-sidebar',
  components: {
  },
  props: {
    minimized: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      items: [],
    }
  },
  methods: {
    newpage () {
      this.$loading.show()
    },
    validateClass (refData) {
      if (refData.indexOf('vuestic-') === 0) {
        return ' vuestic-iconset ' + refData
      } else {
        return ' fa ' + refData
      }
    },
    callLoadMenu () {
      let loader = this.$loading.show()
      if (this.$session.get('IberoJWTAdminLogin').idPerson !== undefined) {
        IberoHelpers.getMenuList(this.$store, this.$session.get('IberoJWTAdminLogin').idPerson)
      }
      // IberoHelpers.getMenuList(this.$store, '236963')

      if (this.$session.get('IberoJWTAdminLogin').termsConditions === undefined) {
        // alert('is undefined');
        // alert(this.$session.get('IberoJWTAdmin').unique_name);
        this.$router.push({ name: 'mserrorlogin' })
        loader.hide()
      } else if (!this.$session.get('IberoJWTAdminLogin').termsConditions) {
        this.$router.push({ name: 'account' })
        loader.hide()
      } else {
        var ListMenu = IberoHelpers.getMenuData(this.$store, 1, this.$session.get('IberoJWTAdminLogin').idPerson)
        // var ListMenu = IberoHelpers.getMenuData(this.$store, 1,  '236963')
        ListMenu.then(Response => {
          this.items = Response.data
          if (this.$route.params.externalLink !== undefined) {
            if (this.$route.params.externalLink === 'CASEID2') {
              this.$router.push({ path: '/admin/CreateCase/2' })
            }
          }
          loader.hide()
        })
      }
    },
  },
  created: function () {
    if (this.$session.get('IberoJWTAdminLogin') !== undefined) {
      this.callLoadMenu()
    } else {
      this.$session.remove('IberoJWTAdminLogin')
      this.$router.push({ name: 'not-found-simple' })
    }
  },
}
</script>
<style>
.va-sidebar {
  background: #4A4848 !important;
  color: #e5e7eb !important;
  border-right: 1px solid #1f2937;
}

.va-sidebar-link {
  color: #cbd5e1 !important;
  border-radius: 10px;
  margin: 4px 8px;
  transition: all 0.25s ease;
  padding: 10px 12px !important;
}

.va-sidebar-link:hover {
  background: rgba(59, 130, 246, 0.15) !important;
  color: #ffffff !important;
  transform: translateX(3px);
}

.va-sidebar-link--active {
  background: #DFC14E !important;
  color: #fff !important;
  box-shadow: 0 4px 12px rgba(208, 171, 75, 0.4);
}

.va-icon,
.sidebar-menu-item-icon {
  color: #94a3b8 !important;
  font-size: 18px;
  transition: color 0.2s ease;
}

.va-sidebar-link--active .va-icon {
  color: #fff !important;
}

.va-sidebar-link-group__title {
  color: #94a3b8 !important;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.va-sidebar-link-group__content {
  padding-left: 10px;
}

.va-sidebar::-webkit-scrollbar {
  width: 6px;
}

.va-sidebar::-webkit-scrollbar-thumb {
  background: #334155;
  border-radius: 6px;
}

.va-sidebar--minimized .va-sidebar-link {
  margin: 6px auto;
  justify-content: center;
}

.va-sidebar__toggle-button {
  display: none !important;
}

.va-sidebar-link__after {
  display: none !important;
}
</style>